export default {
  IDENTIFIER_TYPE: [
    'Identifier_Type',
    'Identifier Type',
    'IdentifierType',
    'SecurityIDType',
    'Security ID Type',
    'SecurityID Type',
    'InstrumentIDType',
    'Instrument ID Type',
    'InstrumentID Type',
  ],
  IDENTIFIER: [
    'Identifier',
    'SecurityID',
    'Security ID',
    'InstrumentID',
    'Instrument ID',
  ],
  TRADE_DATETIME: [
    'TradeDate',
    'TradeDateTime',
    'TradeTime',
    'Trade_Date',
    'Trade_Date_Time',
    'Trade_DateTime',
    'Trade_Time',
    'ExecutionDate',
    'ExecutionDateTime',
    'ExecutionTime',
    'Execution_Date',
    'Execution_Date_Time',
    'Execution_DateTime',
    'Execution_Time',
    'Trade Date & Time',
    'Trade DateTime',
  ],
  TRADE_PRICE: [
    'Price',
    'TradePrice',
    'Trade Price',
    'ExecutionPrice',
    'Execution Price',
    'ExecPrice',
    'Exec Price',
    'Trade_Price',
    'Execution_Price',
    'Exec_Price',
  ],
  SIDE: ['Side', 'Side String', 'Side_String', 'SideStr', 'Side_Str'],
  NOTIONAL_TRADED: [
    'Amount',
    'Trade Amount',
    'TradeAmount',
    'TradedAmount',
    'Traded Amount',
    'Volume',
    'TradeVolume',
    'Trade Volume',
    'TradedVolume',
    'Traded Volume',
    'Notional',
    'NotionalTraded',
    'Traded_Amount',
    'Trade_Volume',
    'Traded_Volume',
    'Notional_Traded',
    'Notional Traded',
  ],
  ORDER_ID: ['Order ID', 'OrderID', 'Order_ID'],
  TRADE_ID: [
    'Trade ID',
    'TradeID',
    'Execution ID',
    'ExecutionID',
    'Deal ID',
    'DealID',
    'Trade_ID',
    'Execution_ID',
    'Deal_ID',
  ],
  PORTFOLIO_ID: ['Portfolio', 'Portfolio ID', 'PortfolioID', 'Portfolio_ID'],
  ORDER_DATETIME: [
    'Order Date',
    'OrderDate',
    'Order Date Time',
    'OrderDateTime',
    'OrderTime',
    'Order_Date',
    'Order_Date_Time',
    'Order_DateTime',
    'Order_Time',
    'Order DateTime',
  ],
  NOTIONAL_ORDERED: [
    'Notional Ordered',
    'NotionalOrdered',
    'Notional_Ordered',
    'AmountOrdered',
    'Amount Ordered',
    'Amount_Ordered',
    'OrderAmount',
    'Order Amount',
    'Order_Amount',
  ],
  ORDER_TYPE: ['Order Type', 'OrderType', 'Order_Type'],
  TRADE_TYPE: ['Trade Type', 'TradeType', 'Trade_Type'],
  BENCHMARK: ['Benchmark', 'Bmrk', 'Bm'],
  EXPLICIT_COST: [
    'Explicit Cost',
    'ExplicitCost',
    'Explicit_Cost',
    'ExplicitCosts',
    'Explicit_Costs',
    'Commission',
    'Commisions',
    'Comm',
    'Fee',
    'Fees',
    'Tax',
    'Taxes',
  ],
  SECURITY_TYPE: ['Security Type', 'SecurityType', 'Security_Type'],
  INSTRUMENT_TYPE: ['Instrument_Type', 'InstrumentType', 'Instrument Type'],
  SECURITY_SUBTYPE: [
    'Security Sub Type',
    'SecuritySubType',
    'Security_Sub_Type',
    'Security_SubType',
  ],
  DESCRIPTION: ['Desc', 'Description'],
  DEAL_TYPE: ['Price_Type', 'PriceType', 'Price Type', 'Deal Type', 'DealType'],
  TRADE_CAPACITY: ['Trade Capacity', 'TradeCapacity', 'Trade_Capacity'],
  TRADER: [
    'Trader',
    'TraderName',
    'Trader Name',
    'Trader_Name',
    'TraderID',
    'Trader ID',
    'Trader_ID',
    'TraderCode',
    'Trader Code',
    'Trader_Code',
  ],
  PM: ['PM', 'PortfolioManager', 'Portfolio_Manager', 'Portfolio Manager'],
  TRADE_DESK: ['Desk', 'TradeDesk', 'Trade Desk', 'Trade_Desk'],
  DESK_LOCATION: ['Location', 'Desk_Location', 'DeskLocation', 'Desk Location'],
  BROKER: [
    'Broker',
    'BrokerName',
    'Broker Name',
    'Broker_Name',
    'BrokerID',
    'Broker ID',
    'Broker_ID',
    'BrokerCode',
    'Broker Code',
    'Broker_Code',
  ],
  DEALER: [
    'Dealer',
    'DealerName',
    'Dealer Name',
    'Dealer_Name',
    'DealerID',
    'Dealer ID',
    'Dealer_ID',
    'DealerCode',
    'Dealer Code',
    'Dealer_Code',
  ],
  PLATFORM: ['Platform', 'Platform_Name', 'Platform Name'],
  VENUE: [
    'Venue',
    'TradingVenue',
    'Trading Venue',
    'Trading_Venue',
    'TradeVenue',
    'Trade Venue',
    'Trade_Venue',
  ],
  COVER_PRICE: ['Cover_Price', 'CoverPrice', 'Cover Price'],
  LIMIT_PRICE: ['Limit_Price', 'LimitPrice', 'Limit Price'],
  EVENT_TYPE: ['Event_Type', 'EventType', 'Event Type'],
  INSTRUCTIONS: ['Instructions'],
  STATUS: ['Status', 'Trade_Status', 'TradeStatus', 'Trade Status'],
  ACCOUNT: ['Account', 'AccountName', 'Account_Name', 'Account Name'],
  FUND: ['Fund', 'FundType', 'Fund_Type', 'Fund Type'],
  STRATEGY: ['Strategy', 'StrategyType', 'Strategy_Type', 'Strategy Type'],
  CUSTOM_BENCHMARK_1: [
    'Custom_Benchmark_1',
    'CustomBenchmark1',
    'Custom_Benchmark1',
    'CustomBenchmark_1',
    'Custom Benchmark 1',
  ],
  CUSTOM_BENCHMARK_2: [
    'Custom_Benchmark_2',
    'CustomBenchmark2',
    'Custom_Benchmark2',
    'CustomBenchmark_2',
    'Custom Benchmark 2',
  ],
  CUSTOM_BENCHMARK_3: [
    'Custom_Benchmark_3',
    'CustomBenchmark3',
    'Custom_Benchmark3',
    'CustomBenchmark_3',
    'Custom Benchmark 3',
  ],
  CUSTOM_BENCHMARK_4: [
    'Custom_Benchmark_4',
    'CustomBenchmark4',
    'Custom_Benchmark4',
    'CustomBenchmark_4',
    'Custom Benchmark 4',
  ],
  OTHER_1: ['Other_1', 'Other1', 'Other 1', 'Other'],
  CURRENCY: ['Currency', 'Curr', 'Cur', 'Ccy'],
  CUSTOM_1: ['Custom_1', 'Report_Date'],
  CUSTOM_2: ['Custom_2', 'Trade_Insertion_Datetime'],
  CUSTOM_3: ['Custom_3'],
  LEGAL_ENTITY: ['entity', 'Entity', 'ENTITY'],
};
